import ViewService from '../../../services/ViewService';
import { ZdsIcon, ZdsLink } from '@zig-design-system/ui-components-react';
import Translation from '../../../../Shared/components/Translation';
import React, { useContext } from 'react';
import { UnitContext } from '../../../context/UnitContext';
import { StringParam, useQueryParam } from 'use-query-params';
const ViewLinks = (ignoreViews) => {
    const { state, dispatch } = useContext(UnitContext);
    let viewLinks = [];
    const [viewQueryParam, setViewQueryParam] = useQueryParam('view', StringParam);
    const handleViewChange = (e) => {
        const newView = e.target.id.split('-')[0];
        setViewQueryParam(newView, 'replaceIn');
        newView === 'map' ? ViewService.setFullWidth() : ViewService.setRegularWidth();
        dispatch({
            type: 'changeView',
            value: newView,
        });
    };
    ViewService.getAll()
        .filter((view) => view.name !== state.currentView || (Array.isArray(ignoreViews) && ignoreViews.includes(view.name)))
        .forEach((view) => {
        viewLinks.push(React.createElement(ZdsLink, { className: "zds-caption zds-bold", key: view.name, id: view.name + '-view-link', "icon-position": "start", onZdsClick: handleViewChange, onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    handleViewChange(e);
                }
            } },
            React.createElement(ZdsIcon, { size: "md", name: view.icon, slot: "icon", className: "" }),
            React.createElement("span", { className: "zds-hidden md:zds-inline " },
                React.createElement(Translation, { item: view.label }))));
    });
    return React.createElement(React.Fragment, null,
        " ",
        viewLinks,
        " ");
};
export default ViewLinks;
